<template>
    <div class="row m-1 mt-2">

        <div class="col-12">
            <div class="card">

                <div class="card-body">
                    <div class="row">

                        <div class="col-12 mb-2">
                            <h1>Statistiche pratiche</h1>
                            
                            <router-link class="btn btn-sm btn-success" :to="{name:'route-index'}">
                                <font-awesome-icon icon="arrow-left"></font-awesome-icon> Torna all'elenco pratiche
                            </router-link>
                        </div>
                        <div class="col-12">
                            <b-row class="m-5">
                                <b-col sm="6" lg="3" v-if="!isOperator">
                                    <div class="social-box">
                                        <i>Da riscontrare</i>
                                        <div class="chart-wrapper">

                                        </div>
                                        <ul>
                                            <li>
                                                <strong>{{open}}</strong>
                                                <span>nr</span>
                                            </li>
                                            <li>
                                                <strong>{{(open/total*100).toFixed(2)}}</strong>
                                                <span>%</span>
                                            </li>
                                        </ul>
                                    </div><!--/.social-box-->
                                </b-col>
                                <b-col sm="6" lg="3">
                                    <div class="social-box active">
                                        <i>In corso</i>
                                        <div class="chart-wrapper">

                                        </div>
                                        <ul>
                                            <li>
                                                <strong>{{active}}</strong>
                                                <span>nr</span>
                                            </li>
                                            <li>
                                                <strong>{{(active/total*100).toFixed(2)}}</strong>
                                                <span>%</span>
                                            </li>
                                        </ul>
                                    </div><!--/.social-box-->
                                </b-col>
                                <b-col sm="6" lg="3">
                                    <div class="social-box success">
                                        <i>Evase</i>
                                        <div class="chart-wrapper">

                                        </div>
                                        <ul>
                                            <li>
                                                <strong>{{closed}}</strong>
                                                <span>nr</span>
                                            </li>
                                            <li>
                                                <strong>{{(closed/total*100).toFixed(2)}}</strong>
                                                <span>%</span>
                                            </li>
                                        </ul>
                                    </div><!--/.social-box-->
                                </b-col>
                                <b-col sm="6" lg="3">
                                    <div class="social-box ko">
                                        <i>Annullate</i>
                                        <div class="chart-wrapper">

                                        </div>
                                        <ul>
                                            <li>
                                                <strong>{{ko}}</strong>
                                                <span>nr</span>
                                            </li>
                                            <li>
                                                <strong>{{(ko/total*100).toFixed(2)}}</strong>
                                                <span>%</span>
                                            </li>
                                        </ul>
                                    </div><!--/.social-box-->
                                </b-col>

                            </b-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- /.col -->
    </div>
    
</template>
<style>
    .social-box {
        min-height: 132px;
        margin-bottom: 1.5rem;
        text-align: center;
        background: #fff;
        border: 1px solid #d1d4d7;
    }
    .social-box i {
            display: block;
            margin: -1px -1px 0;
            font-size: 29px;
            line-height: 59px;
            background: #e4e5e6;
        }

        .social-box.ko i {
            background: #f86c6b;
            color: #fff
        }
        .social-box.active i {
            background: #63C2DE;
            color: #fff
        }

        .social-box.success i {
            background: #4dbd74;
            color: #fff
        }

  
</style>
<script>
    import CardLine1ChartExample from '../dashboard/CardLine1ChartExample'
    import CardLine2ChartExample from '../dashboard/CardLine2ChartExample'
    import CardLine3ChartExample from '../dashboard/CardLine3ChartExample'
    import CardBarChartExample from '../dashboard/CardBarChartExample'
    import MainChartExample from '../dashboard/MainChartExample'
    import SocialBoxChartExample from '../dashboard/SocialBoxChartExample'

    import axios from 'axios';

    export default {
        name: 'dashboard',
        computed: {

            isAdministrative: function () {

                var u = false;

                for (var i = 0; i < this.$store.state.user.roles.length; i++) {
                    if (this.$store.state.user.roles[i] == "administrative" || this.$store.state.user.roles[i] == "administrator") {
                        u = true;
                        break;
                    }
                }

                return u;
            },
            isOperator: function () {

                var u = false;

                for (var i = 0; i < this.$store.state.user.roles.length; i++) {
                    if (this.$store.state.user.roles[i] == "operator" ) {
                        u = true;
                        break;
                    }
                }

                return u;
            },
        },
        components: {
           
            CardLine1ChartExample,
            CardLine2ChartExample,
            CardLine3ChartExample,
            CardBarChartExample,
            MainChartExample,
            SocialBoxChartExample,
          
        },
        data: function () {
            return {
                chartData: [],
                total: 0,
                open: 0,
                closed: 0,
                ko: 0,
                active:0
        
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            variant(value) {
                let $variant
                if (value <= 25) {
                    $variant = 'info'
                } else if (value > 25 && value <= 50) {
                    $variant = 'success'
                } else if (value > 50 && value <= 75) {
                    $variant = 'warning'
                } else if (value > 75 && value <= 100) {
                    $variant = 'danger'
                }
                return $variant
            },
            flag(value) {
                return 'flag-icon flag-icon-' + value
            },
            getData() {
                var me = this;
                axios.get("inheritances/chart").then((result) => {
                    me.chartData = result.data;
                    me.total = 0;
                    me.active = 0;
                    for (var i = 0; i < me.chartData.length; i++) {
                        me.total += me.chartData[i].count;
                        if (me.chartData[i].state == "KO") {
                            me.ko = me.chartData[i].count;
                        }
                        else if (me.chartData[i].state == "Open") {
                            me.open = me.chartData[i].count;
                        }
                        else if (me.chartData[i].state == "Sent") {
                            me.closed = me.chartData[i].count;
                        }
                        else {
                            me.active += me.chartData[i].count;
                        }
                    }
                });
            }
        }
    }
</script>
